import { VehicleSkinsValues } from '../vehicle/CharacterSpine';
import { MatterUpdater } from '../../core/modules/MatterUpdater';
import { Driver, DriverProfile, VehicleDetails, VehicleHandling } from '../vehicle/Vehicle';
import { LevelManager } from '../LevelManager';
import { VehicleManager } from './VehicleManager';
import { VehicleHero } from '../vehicle/VehicleHero';
import { VehicleVillain } from '../vehicle/VehicleVillain';
import { Character, CharacterNameValues } from './Character';

export class VehicleFactory {
  protected scene: Phaser.Scene;
  protected levelManager: LevelManager;
  protected vehicleManager: VehicleManager;
  protected matterUpdater: MatterUpdater;
  protected vehicleLayer: Phaser.GameObjects.Layer;
  protected gameUILayer: Phaser.GameObjects.Layer;
  // protected deltaStepping: number;

  constructor(
    scene: Phaser.Scene,
    levelManager: LevelManager,
    vehicleManager: VehicleManager,
    matterUpdater: MatterUpdater,
    vehicleLayer: Phaser.GameObjects.Layer,
    gameUILayer: Phaser.GameObjects.Layer,
    baseAIProfile?: DriverProfile
  ) {
    this.scene = scene;
    this.levelManager = levelManager;
    this.vehicleManager = vehicleManager;
    this.matterUpdater = matterUpdater;
    this.vehicleLayer = vehicleLayer;
    this.gameUILayer = gameUILayer;
    // this.deltaStepping = this.matterUpdater.TimeStep;
  }

  public makeHeroProfile(character: CharacterNameValues): DriverProfile {
    return {
      driver: character,
      driverTeam: Driver.Hero,
      skin: Character.characterSkinLookup[character],
      equipment: Character.characterToEquipmentLookup[character]
    };
  }

  public makeVillainProfile(character: CharacterNameValues): DriverProfile {
    return {
      driver: character,
      driverTeam: Driver.Villain,
      skin: Character.characterSkinLookup[character],
      equipment: Character.characterToEquipmentLookup[character]
    };
  }

  public makeHeroVehicle(driverProfile: DriverProfile, vehicleHandling: VehicleHandling, startLane: number, indentX: number, hasShadow: boolean): VehicleHero {
    let vehicleDetails: VehicleDetails = {
      vehicleLayer: this.vehicleLayer,
      gameUILayer: this.gameUILayer,
      startIndentX: indentX,
      startLane: startLane,
      endPointX: this.levelManager.LevelEndPointX,
      hasShadow: hasShadow
    };

    let vehicle = new VehicleHero(this.scene, this.vehicleManager, driverProfile, vehicleHandling, this.levelManager.CurrentTheme.roadDetails, vehicleDetails);
    this.vehicleManager.registerVehicle(vehicle);
    this.vehicleLayer.add(vehicle);
    this.matterUpdater.add(vehicle.matterUpdate, vehicle, 0);

    return vehicle;
  }

  public makeVillainVehicle(driverProfile: DriverProfile, vehicleHandling: VehicleHandling, startLane: number, indentX: number, hasShadow: boolean): VehicleVillain {
    let vehicleDetails: VehicleDetails = {
      vehicleLayer: this.vehicleLayer,
      gameUILayer: this.gameUILayer,
      startIndentX: indentX,
      startLane: startLane,
      endPointX: this.levelManager.LevelEndPointX,
      hasShadow: hasShadow
    };

    let vehicle = new VehicleVillain(
      this.scene,
      this.vehicleManager,
      driverProfile,
      vehicleHandling,
      this.levelManager.CurrentTheme.roadDetails,
      vehicleDetails
    );
    this.vehicleManager.registerVehicle(vehicle);
    this.vehicleLayer.add(vehicle);
    this.matterUpdater.add(vehicle.matterUpdate, vehicle, 0);

    return vehicle;
  }
}
